import cn from 'classnames';

import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import LandingPageImage from 'components/landing/LandingPageImage';
import LandingPageLink from 'components/landing/LandingPageLink';
import {
  setInlineBackgroundColor,
  setInlineTextColor
} from 'helpers/LandingPageUtils';
import { stripSpecialChars } from 'helpers';
import css from 'styles/components/landing/melodyGrid.scss';

const MelodyGrid = ({ slotName, slotDetails, onLandingComponentClick, shouldLazyLoad, slotHeartsData }) => {
  const { products, title, link, ctacopy, copy, subtext, bgcolor, gae, textcolor, componentName, image, alt, flip, monetateId } = slotDetails;
  const eventLabel = (componentName === 'productSearch') ? 'productSearch' : 'melodyGrid';

  const makeTitle = () => title && <figcaption style={setInlineTextColor(textcolor)}>{title}</figcaption>;

  const makeCopy = () => copy && <p style={setInlineTextColor(textcolor)}>{copy}</p>;

  const makeSubText = () => subtext && <p className={css.subtext}>{subtext}</p>;

  const makeCallToAction = () => ctacopy && <button className={css.cta}>{ctacopy}</button>;

  const makeMainImage = () => image &&
    <LandingPageImage
      src={image}
      alt={alt}
      shouldLazyLoad={shouldLazyLoad}
      className={css.lazyImg}
    />;

  const makeMainContent = () => {
    const styling = (textcolor === 'white') ? css.mainContentCtaWhite : css.mainContentCtaDefault;
    const contents = (
      <div className={cn(css.mainContent, styling)} style={setInlineBackgroundColor(bgcolor)}>
        {makeTitle()}
        {makeCopy()}
        {makeSubText()}
        {makeCallToAction()}
        {makeMainImage()}
      </div>
    );
    const linkProps = {
      'onClick': onLandingComponentClick,
      'data-eventlabel': eventLabel,
      'data-eventvalue': gae || title
    };
    return link
      ?
      <LandingPageLink url={link} {...linkProps}>
        {contents}
      </LandingPageLink>
      :
      contents;
  };

  return (
    <div className={cn(css.mProductGrid, { [css.flipped]: flip === 'true' })} data-slot-id={slotName} data-monetate-id={monetateId}>
      <figure>
        {makeMainContent()}
      </figure>
      <div className={css.items}>
        {products.map((product, i) => {
          const { msaImageUrl, thumbnailImageUrl, src } = product;
          return <MelodyCardProduct
            key={`${stripSpecialChars(msaImageUrl || thumbnailImageUrl || src)}_${i}`}
            cardData={product}
            componentStyle="melodyGrid"
            eventLabel={eventLabel}
            melodyCardTestId="trendingProduct"
            onComponentClick={onLandingComponentClick}
            heartsData={slotHeartsData} />;
        })}
      </div>
    </div>
  );
};

export default MelodyGrid;
